<template>
  <div>
    <dd-section-title>
      実運送体制管理
      <div style="font-size:small">
        <a :href="kamotsuJigyohoKaiseiSiteUrl" target="_blank">
          改正貨物自動車運送事業法（令和７年４月１日施行）について(別ウインドウが開きます)
        </a>
        [{{ kamotsuJigyohoKaiseiSiteUrl }}]
      </div>
    </dd-section-title>

    <v-row no-gutters class="pl-2">
      <v-col :xs="12" :sm="12" :md="12" :lg="6" :xl="6" :cols="12" class="px-1">
        <v-radio-group
          label="元請け運送事業者ですか？"
          v-model="localMotoukeFlg"
          :readonly="readOnly"
          @change = "onChangeMotoukeFlg"
          row>
          <dd-radio-button
            label="はい"
            :value="true"
          />
          <dd-radio-button
            label="いいえ"
            :value="false"
          />
        </v-radio-group>
      </v-col>
    </v-row>
    <v-row no-gutters class="pl-2">
      <div style="color: #5f88aa;font-weight: bold;">
        〇真荷主情報
      </div>
      <div v-show="rec.motoukeFlg" style="color: rgb(255 0 0);font-weight: bold;font-size: small;align-content: end;margin-left: 10px;">
        ※元請け事業者は、①真荷主からの注文書受領②真荷主への注文確認書の送付が必要です。
      </div>
    </v-row>
    <v-row no-gutters class="pl-2">
      <v-col :xs="12" :sm="8" :md="8" :lg="4" :xl="4" :cols="12" class="px-1">
        <dd-text-box
          label="真荷主名称"
          v-model="rec.maninushiNm"
          ref="maninushiNm"
          :length="50"
          :readonly="readOnly"
          :valueType="Ctrls.InputTypes.Free"
          tooltipText="この配送の真荷主（依頼元）を入力しましょう。"
          :tooltipBottom="true"
          :enableToolTip="helpUseFlg"
          @blur="inputManinushiNm"
          />
      </v-col>
    </v-row>
    <div v-show="rec.motoukeFlg">
      <v-row no-gutters class="pl-2">
        <v-col :xs="12" :sm="6" :md="6" :lg="4" :xl="4" :cols="12" class="px-1">
          <v-row no-gutters style="padding-top:0px !important;padding-bottom:0px !important;">
            <v-col :cols="6" class="px-1 mt-6">
              <div>
                <dd-checkbox
                  label="真荷主から注文書受領済み"
                  v-model="rec.chumonshoReceiveZumiFlg"
                  :readonly="readOnly"
                  ref="chumonshoReceiveZumiFlg"
                  tooltipText="この配送の真荷主（依頼元）から注文書を受領したら、チェックを入れましょう。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                />
              </div>
            </v-col>
            <v-col :cols="6" class="px-1">
              <dd-drop-down
                label="注文書受領方法"
                v-model="rec.chumonshoReceiveSbt"
                placeholder="選択してください"
                :items="filteredRenrakuShudanList"
                :readonly="readOnly"
                tooltipText="注文書を受領した方法を選択しましょう。<br>選択肢にない場合は、「ユーザ種別マスタ」から登録することができます。<br>種別大分類「SBT062:連絡手段」"
                :tooltipBottom="true"
                :enableToolTip="helpUseFlg"
                />
            </v-col>
          </v-row>
        </v-col>
        <v-col :xs="12" :sm="6" :md="6" :lg="4" :xl="4" :cols="12" class="px-1">
          <dd-text-box
            label="注文書受領方法備考"
            v-model="rec.chumonshoReceiveBiko"
            ref="chumonshoReceiveBiko"
            :length="100"
            :readonly="readOnly"
            :valueType="Ctrls.InputTypes.Free"
            tooltipText="注文書を受領した方法について、メモしておきたいことを入力しましょう。"
            :tooltipBottom="true"
            :enableToolTip="helpUseFlg"
            />
        </v-col>
        <v-col :xs="12" :sm="6" :md="6" :lg="4" :xl="4" :cols="12" class="px-1">
          <v-row no-gutters style="padding-top:0px !important;padding-bottom:0px !important;">
            <v-col :cols="8" class="px-1 mt-6">
              <div>
                <dd-checkbox
                  label="真荷主へ注文書確認書送付済み"
                  v-model="rec.chumonkakuninshoSendZumiFlg"
                  :readonly="readOnly"
                  ref="chumonkakuninshoSendZumiFlg"
                  tooltipText="この配送の真荷主（依頼元）へ注文確認書を交付したら、チェックを入れましょう。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                />
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <div v-show="yoshaFlg">
        <v-row no-gutters class="pl-2">
          <div style="color: #5f88aa;font-weight: bold;">
            〇傭車先情報
          </div>
          <div style="color: rgb(255 0 0);font-weight: bold;font-size: small;align-content: end;margin-left: 10px;">
            ※傭車に依頼する場合、①傭車先への発注書送付②実運送体制管理簿の作成が必要です。
          </div>
        </v-row>

        <v-row no-gutters class="pl-2">
          <v-col :xs="12" :sm="6" :md="6" :lg="4" :xl="4" :cols="12" class="px-1">
            <v-row no-gutters style="padding-top:0px !important;padding-bottom:0px !important;">
              <v-col :cols="8" class="px-1 mb-4">
                <div>
                  <dd-checkbox
                    label="傭車先へ発注書送付済み"
                    v-model="rec.hacchushoSendZumiFlg"
                    :readonly="readOnly"
                    ref="hacchushoSendZumiFlg"
                    tooltipText="傭車先へ発注書を交付したら、チェックを入れましょう。"
                    :tooltipBottom="true"
                    :enableToolTip="helpUseFlg"
                    />
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row no-gutters class="pl-2">
          <div style="color: #5f88aa;font-weight: bold;">
              〇実運送体制管理簿
          </div>
        </v-row>
        <dd-jitsu-unso-taisei-kanribo-spread
          :rec="rec"
          ref="ddJitsuUnsoTaiseiKanriboSpread"
          :yoshaFlg="yoshaFlg"
          :yoshaId="yoshaId"
          :yoshaSharyoId="yoshaSharyoId"
          :yoshaSharyoNo="yoshaSharyoNo"
          :yoshaJininId="yoshaJininId"
          :readOnly="readOnly"
        />
      </div>
    </div>
    <div v-show="!rec.motoukeFlg">
      <v-row no-gutters class="pl-2">
        <div style="color: #5f88aa;font-weight: bold;">
          〇元請け先情報
        </div>
        <div v-show="!yoshaFlg" style="color: rgb(255 0 0);font-weight: bold;font-size: small;align-content: end;margin-left: 10px;">
          ※配送完了後、元請け先への完了報告が必要です。
        </div>
      </v-row>

      <v-row no-gutters class="pl-2">
        <v-col :xs="12" :sm="8" :md="8" :lg="4" :xl="4" :cols="12" class="px-1">
          <dd-text-box
            label="元請け先名称"
            v-model="rec.motoukeNm"
            ref="motoukeNm"
            :length="50"
            :readonly="readOnly"
            :valueType="Ctrls.InputTypes.Free"
            tooltipText="この配送の元請け先を入力しましょう。"
            :tooltipBottom="true"
            :enableToolTip="helpUseFlg"
            />
        </v-col>
        <v-col :xs="12" :sm="6" :md="6" :lg="3" :xl="3" :cols="12" class="px-1">
          <v-row no-gutters style="padding-top:0px !important;padding-bottom:0px !important;">
            <v-col :cols="6" class="px-1">
              <dd-numeric-box
                v-if="!yoshaFlg"
                label="受注請負階層"
                v-model="rec.juchuUkeoiKaiso"
                ref="juchuUkeoiKaiso"
                :integerDigit="3"
                :minorDigit="0"
                :length="3"
                :max=999
                :min=-999
                :readonly="readOnly"
                tooltipText="受注時点の、自社請負階層を入力しましょう。<br>例：二次受けであれば「2」、三次受けであれば「3」を入力します。"
                :tooltipBottom="true"
                :enableToolTip="helpUseFlg"
              />
              <dd-numeric-box
                v-else
                label="傭車先請負階層"
                v-model="rec.hacchusakiUkeoiKaiso"
                ref="hacchusakiUkeoiKaiso"
                :integerDigit="3"
                :minorDigit="0"
                :length="3"
                :max=999
                :min=-999
                :readonly="readOnly"
                tooltipText="発注時点の、傭車先請負階層を入力しましょう。<br>例：二次受けであれば「2」、三次受けであれば「3」を入力します。"
                :tooltipBottom="true"
                :enableToolTip="helpUseFlg"
              />
            </v-col>
            <v-col :cols="6" class="px-1">
              <dd-drop-down
                label="元請け先連絡方法"
                v-model="rec.motoukeRenrakuSbt"
                placeholder="選択してください"
                :items="filteredRenrakuShudanList"
                :readonly="readOnly"
                tooltipText="元請け先への連絡方法を選択しましょう。<br>選択肢にない場合は、「ユーザ種別マスタ」から登録することができます。<br>種別大分類「SBT062:連絡手段」"
                :tooltipBottom="true"
                :enableToolTip="helpUseFlg"
                />
            </v-col>
          </v-row>
        </v-col>
        <v-col :xs="12" :sm="12" :md="12" :lg="5" :xl="5" :cols="12" class="px-1">
          <v-row no-gutters style="padding-top:0px !important;padding-bottom:0px !important;">
            <v-col :cols="9" class="px-1">
              <dd-text-box
                label="元請け先連絡方法備考"
                v-model="rec.motoukeRenrakuBiko"
                ref="motoukeRenrakuBiko"
                :length="100"
                :readonly="readOnly"
                :valueType="Ctrls.InputTypes.Free"
                tooltipText="元請け先への連絡方法について、メモしておきたいことを入力しましょう。"
                :tooltipBottom="true"
                :enableToolTip="helpUseFlg"
                />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row no-gutters class="pl-2">
        <v-col class="px-1">
          <dd-text-area
            label="元請け連絡先"
            v-model="rec.motoukeRenrakusaki"
            ref="motoukeRenrakusaki"
            :length="100"
            :rows="3"
            :readonly="readOnly"
            :valueType="Ctrls.InputTypes.Free"
            tooltipText="元請け先の連絡先を入力しましょう。<br>改行して、複数行入力することができます。<br>例：電話番号、FAX番号、メールアドレスなど"
            :tooltipBottom="true"
            :enableToolTip="helpUseFlg"
            />
        </v-col>
      </v-row>
      <v-row no-gutters class="pl-2">
        <v-col :xs="12" :sm="8" :md="8" :lg="4" :xl="4" :cols="12" class="px-1">
          <v-row no-gutters style="padding-top:0px !important;padding-bottom:0px !important;">
            <v-col :cols="6" class="px-1 mt-6">
              <div>
                <dd-checkbox
                label="依頼主から注文書受領済み"
                v-model="rec.chumonshoReceiveZumiFlg"
                :readonly="readOnly"
                ref="chumonshoReceiveZumiFlg"
                tooltipText="依頼主(荷主)から注文書を受領したら、チェックを入れましょう。"
                :tooltipBottom="true"
                :enableToolTip="helpUseFlg"
                />
              </div>
            </v-col>
            <v-col :cols="6" class="px-1">
              <dd-drop-down
                label="注文書受領方法"
                v-model="rec.chumonshoReceiveSbt"
                placeholder="選択してください"
                :items="filteredRenrakuShudanList"
                :readonly="readOnly"
                tooltipText="注文書を受領した方法を選択しましょう。<br>選択肢にない場合は、「ユーザ種別マスタ」から登録することができます。<br>種別大分類「SBT062:連絡手段」"
                :tooltipBottom="true"
                :enableToolTip="helpUseFlg"
                />
            </v-col>
          </v-row>
        </v-col>
        <v-col :xs="12" :sm="8" :md="8" :lg="4" :xl="4" :cols="12" class="px-1">
          <dd-text-box
            label="注文書受領方法備考"
            v-model="rec.chumonshoReceiveBiko"
            ref="chumonshoReceiveBiko"
            :length="100"
            :readonly="readOnly"
            :valueType="Ctrls.InputTypes.Free"
            tooltipText="注文書を受領した方法をについて、メモしておきたいことを入力しましょう。"
            :tooltipBottom="true"
            :enableToolTip="helpUseFlg"
            />
        </v-col>
      </v-row>
      <div v-show="!yoshaFlg">
        <v-row no-gutters class="pl-2">
          <v-col :xs="12" :sm="8" :md="8" :lg="4" :xl="4" :cols="12" class="px-1">
            <v-row no-gutters style="padding-top:0px !important;padding-bottom:0px !important;">
              <v-col :cols="6" class="px-1 mt-6 mb-1">
                <div>
                  <dd-checkbox
                    label="元請け先へ完了報告済み"
                    v-model="rec.motoukeHokokuZumiFlg"
                    :readonly="readOnly"
                    ref="motoukeHokokuZumiFlg"
                    tooltipText="この配送の元請け先へ完了報告を終えたら、チェックを入れましょう。"
                    :tooltipBottom="true"
                    :enableToolTip="helpUseFlg"
                  />
                </div>
              </v-col>
              <v-col :cols="6" class="px-1">
                <dd-date-box
                  v-if="rec.motoukeHokokuZumiFlg"
                  label="元請け先完了報告日"
                  v-model="rec.motoukeHokokuYmd"
                  ref="motoukeHokokuYmd"
                  :required="false"
                  :readonly="readOnly"
                  max="2999/12/31"
                  min="2000/01/01"
                  tooltipText="この配送の元請け先へ完了報告を行った日を入力しましょう。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                  />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </div>
      <div v-show="yoshaFlg">
        <v-row no-gutters class="pl-2">
          <div style="color: #5f88aa;font-weight: bold;">
            〇傭車先情報
          </div>
          <div style="color: rgb(255 0 0);font-weight: bold;font-size: small;align-content: end;margin-left: 10px;">
            ※傭車に依頼する場合、傭車先への発注書送付が必要です。
          </div>
        </v-row>
        <v-row no-gutters class="pl-2">
          <v-col :xs="12" :sm="8" :md="8" :lg="4" :xl="4" :cols="12" class="px-1">
            <v-row no-gutters style="padding-top:0px !important;padding-bottom:0px !important;">
              <v-col :cols="6" class="px-1">
                <div>
                  <dd-checkbox
                    label="傭車先へ発注書送付済み"
                    v-model="rec.hacchushoSendZumiFlg"
                    :readonly="readOnly"
                    ref="hacchushoSendZumiFlg"
                    tooltipText="傭車先へ発注書を交付したら、チェックを入れましょう。"
                    :tooltipBottom="true"
                    :enableToolTip="helpUseFlg"
                  />
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </div>
    </div>
    <v-row no-gutters class="pl-2 pt-2">
      <div style="color: #5f88aa;font-weight: bold;">
        〇メモ
      </div>
    </v-row>
    <v-row no-gutters class="pl-2">
      <v-col class="px-1">
        <dd-text-area
          label="実運送体制管理メモ"
          v-model="rec.jitsuUnsoHokokuMemo"
          ref="jitsuUnsoHokokuMemo"
          :length="100"
          :rows="3"
          :readonly="readOnly"
          :valueType="Ctrls.InputTypes.Free"
          tooltipText="この配送の実運送体制管理について、メモしておきたいことを入力しましょう。<br>改行して、複数行入力することができます。"
          :tooltipBottom="true"
          :enableToolTip="helpUseFlg"
          />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import flowMixin from '@/mixins/flowMixins'
import indexeddb from '@/ddv2.library/indexeddb'
import DdDateBox from '@/components/DdDateBox'
import DdJitsuUnsoTaiseiKanriboSpread from '@/components/DdJitsuUnsoTaiseiKanriboSpread'

const DdCheckbox = () => import('@/components/DdCheckbox')
const DdDropDown = () => import('@/components/DdDropDown')
const DdNumericBox = () => import('@/components/DdNumericBox.vue')
const DdSectionTitle = () => import('@/components/DdSectionTitle')
const DdTextArea = () => import('@/components/DdTextArea')
const DdTextBox = () => import('@/components/DdTextBox')
const DdRadioButton = () => import('@/components/DdRadioButton')
export default {
  name: 'DdJitsuUnsoTaiseiKanriEdit',
  mixins: [flowMixin],
  components: {
    DdCheckbox,
    DdDateBox,
    DdDropDown,
    DdJitsuUnsoTaiseiKanriboSpread,
    DdNumericBox,
    DdSectionTitle,
    DdTextArea,
    DdTextBox,
    DdRadioButton
  },
  props: {
    /**
     * Object
     */
    rec: Object,
    /**
     * 傭車依頼のときはtrueに
     */
    yoshaFlg: {
      type: Boolean,
      default: false
    },
    /**
     * 傭車先ID
     */
    yoshaId: {
      type: Number,
      default: 0
    },
    /**
     * 傭車車両ID
     */
    yoshaSharyoId: {
      type: Number,
      default: 0
    },
    /**
     * 傭車車番
     */
    yoshaSharyoNo: {
      type: String,
      default: ''
    },
    /**
     * 傭車人員ID
     */
    yoshaJininId: {
      type: Number,
      default: 0
    },
    /**
     * readOnly
     */
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      localMotoukeFlg: this.rec.motoukeFlg
    }
  },
  computed: {
    ...mapGetters({
      shubetsuList: 'DDMasters/mstShubetsu',
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      hinmeiList: 'DDMasters/mstHinmei',
      hacchakuchiList: 'DDMasters/mstHacchakuchi',
      sharyoList: 'DDMasters/vwCMstSharyo',
      eigyoshoJininList: 'DDMasters/vwCMstEigyoshoJininList',
      currentKaishaCode: 'users/currentKaishaCode',
      helpUseFlg: 'users/helpUseFlg',
      systemConfigList: 'DDMasters/msysSystemConfig'
    }),
    kamotsuJigyohoKaiseiSiteUrl () {
      const r = indexeddb.getSystemConfig(this.currentKaishaCode, this.systemConfigList, 'web_url_kamotsu_jigyoho_kaisei_display')
      if (r) {
        return r.configValue1
      }
      return 'https://www.mlit.go.jp/jidosha/jidosha_mn4_000014.html'
    },
    // 連絡手段種別
    filteredRenrakuShudanList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'SBT062')
    }
  },
  watch: {
    'rec.motoukeFlg': {
      handler (val) {
        this.localMotoukeFlg = val
      },
      immediate: true
    },
    localMotoukeFlg (val) {
      this.rec.motoukeFlg = val
      this.setJitsuUnsoTaiseiKanriHeader()
    }
  },
  beforeDestroy () {
  },
  created () {
  },
  mounted () {
    // マスタ読み込み
    this.$store.dispatch('DDMasters/loadMasters', { list: ['mstshubetsu', 'msyssystemconfig'], version: 1 })
  },
  methods: {
    onChangeMotoukeFlg: function (newVal) {
      const self = this
      console.log(self.rec.motoukeFlg, self.yoshaFlg)
      if (newVal && self.yoshaFlg) {
        self.setJitsuUnsoTaiseiKanriHeader()
        if ([undefined, null, ''].includes(self.rec.dispJitsuUnsoTaiseiKanriList) || self.rec.dispJitsuUnsoTaiseiKanriList.length === 0) {
          self.$refs.ddJitsuUnsoTaiseiKanriboSpread.rowAppend(1, null)
        }
      }
    },
    setJitsuUnsoTaiseiKanriHeader: function () {
      return this.$refs.ddJitsuUnsoTaiseiKanriboSpread.setJitsuUnsoTaiseiKanriHeader()
    },
    convertKanriboResult: function (p) {
      return this.$refs.ddJitsuUnsoTaiseiKanriboSpread.convertKanriboResult(p)
    },
    rowAppend: function (p, index) {
      return this.$refs.ddJitsuUnsoTaiseiKanriboSpread.rowAppend(p, index)
    },
    // 実運送体制管理簿の入力補助
    inputManinushiNm: function () {
      if (this.rec.motoukeFlg) {
        if ([undefined, null, ''].includes(this.rec.dispJitsuUnsoTaiseiKanriList) || this.rec.dispJitsuUnsoTaiseiKanriList.length === 0) {
          this.$refs.ddJitsuUnsoTaiseiKanriboSpread.rowAppend(1, null)
        } else {
          this.rec.dispJitsuUnsoTaiseiKanriList.map((elem) => {
            elem.maninushiNm = this.rec.maninushiNm
            return elem
          })
          this.rec.dispJitsuUnsoTaiseiKanriList.splice()
        }
      }
    },
    inputHinmei: function () {
      if (this.rec.motoukeFlg) {
        if ([undefined, null, ''].includes(this.rec.dispJitsuUnsoTaiseiKanriList) || this.rec.dispJitsuUnsoTaiseiKanriList.length === 0) {
          this.$refs.ddJitsuUnsoTaiseiKanriboSpread.rowAppend(1, null)
        } else {
          if (![undefined, null, ''].includes(this.rec.mstHinmeiId)) {
            const hinmeiInfo = indexeddb.getRecord(this.hinmeiList, this.rec.mstHinmeiId)
            const hinmeiNm = ![undefined, null, ''].includes(hinmeiInfo) ? hinmeiInfo.hinmeiNm : ''
            this.rec.dispJitsuUnsoTaiseiKanriList.map((elem) => {
              elem.unsoHinmoku = hinmeiNm
              return elem
            })
          } else if (![undefined, null, ''].includes(this.rec.hinmeiBiko)) {
            this.rec.dispJitsuUnsoTaiseiKanriList.map((elem) => {
              elem.unsoHinmoku = this.rec.hinmeiBiko
              return elem
            })
          }
          this.rec.dispJitsuUnsoTaiseiKanriList.splice()
        }
      }
    },
    inputHacchakuchi: function () {
      if (this.rec.motoukeFlg) {
        if ([undefined, null, ''].includes(this.rec.dispJitsuUnsoTaiseiKanriList) || this.rec.dispJitsuUnsoTaiseiKanriList.length === 0) {
          this.$refs.ddJitsuUnsoTaiseiKanriboSpread.rowAppend(1, null)
        } else {
          if ([undefined, null, ''].includes(this.rec.hatsuchiId) &&
            [undefined, null, ''].includes(this.rec.hatsuchiBiko) &&
            [undefined, null, ''].includes(this.rec.chakuchiId) &&
            [undefined, null, ''].includes(this.rec.chakuchiBiko)) {
            return
          } else {
            let dispHacchakuchi = ''
            if (![undefined, null, ''].includes(this.rec.hatsuchiId)) {
              const hatsuchiInfo = indexeddb.getRecord(this.hacchakuchiList, this.rec.hatsuchiId)
              dispHacchakuchi = ![undefined, null, ''].includes(hatsuchiInfo) ? hatsuchiInfo.hacchakuchiNm : ''
            } else if (![undefined, null, ''].includes(this.rec.hatsuchiBiko)) {
              dispHacchakuchi = this.rec.hatsuchiBiko
            }

            if (![undefined, null, ''].includes(this.rec.chakuchiId)) {
              const chakuchiInfo = indexeddb.getRecord(this.hacchakuchiList, this.rec.chakuchiId)
              const chakuchiNm = ![undefined, null, ''].includes(chakuchiInfo) ? chakuchiInfo.hacchakuchiNm : ''
              dispHacchakuchi = ![undefined, null, ''].includes(dispHacchakuchi) ? dispHacchakuchi + ' ~ ' + chakuchiNm : chakuchiNm
            } else if (![undefined, null, ''].includes(this.rec.chakuchiBiko)) {
              const chakuchiNm = this.rec.chakuchiBiko
              dispHacchakuchi = ![undefined, null, ''].includes(dispHacchakuchi) ? dispHacchakuchi + ' ~ ' + chakuchiNm : chakuchiNm
            }

            this.rec.dispJitsuUnsoTaiseiKanriList.map((elem) => {
              elem.unsoKukan = dispHacchakuchi
              return elem
            })
          }
          this.rec.dispJitsuUnsoTaiseiKanriList.splice()
        }
      }
    },
    inputYoshaInfo: function () {
      if (this.rec.motoukeFlg && this.yoshaFlg) {
        if ([undefined, null, ''].includes(this.rec.dispJitsuUnsoTaiseiKanriList) || this.rec.dispJitsuUnsoTaiseiKanriList.length === 0) {
          this.$refs.ddJitsuUnsoTaiseiKanriboSpread.rowAppend(1, null)
        } else if (this.rec.dispJitsuUnsoTaiseiKanriList.length > 0) {
          if (this.yoshaId > 0) {
            const hacchusakiInfo = indexeddb.getRecord(this.torihikisakiList, this.yoshaId)
            this.rec.dispJitsuUnsoTaiseiKanriList[0].jitsuUnsoJigyoshaNm = hacchusakiInfo ? hacchusakiInfo.torihikisakiNm : ''
          }

          if (![undefined, null, ''].includes(this.yoshaSharyoId)) {
            const yoshaSharyoInfo = indexeddb.getRecord(this.sharyoList, this.yoshaSharyoId)
            this.rec.dispJitsuUnsoTaiseiKanriList[0].jitsuUnsoSharyoNm = ![undefined, null, ''].includes(yoshaSharyoInfo) ? yoshaSharyoInfo.jidoshaHyojiNm : ''
          } else if (![undefined, null, ''].includes(this.yoshaSharyoNo)) {
            this.rec.dispJitsuUnsoTaiseiKanriList[0].jitsuUnsoSharyoNm = this.yoshaSharyoNo
          }

          if (this.yoshaJininId > 0) {
            const yoshaJininInfo = indexeddb.getRecord(this.eigyoshoJininList, this.yoshaJininId)
            this.rec.dispJitsuUnsoTaiseiKanriList[0].jitsuUnsoJomuinNm = ![undefined, null, ''].includes(yoshaJininInfo) ? yoshaJininInfo.jininNmSei : ''
          }
          this.rec.dispJitsuUnsoTaiseiKanriList.splice()
        }
      }
    }
  }
}
</script>
<style scoped>
</style>
